import "bootstrap/dist/css/bootstrap.min.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { FounderAuthProvider } from "./context/FounderAuthContext";
import "./styles/tokens.css";
import "./styles/foundation.css";
import "./styles/components.css";
import "./styles/pages.css";
import "./styles/response-3.css";
import "./styles/response-13.css";
import "./styles/response-15.css";
import "./styles/response-23.css";
import "./styles/response-26.css";
import "./styles/response-27.css";
import "./styles/response-35.css";
import "./styles/shared-shell.css";
import "./styles/global-typography.css";
import "./styles/response-43.css";
import "./styles/response-44.css";
import "./styles/response-45.css";
import "./styles/response-53.css";
import "./styles/response-54.css";
import "./styles/response-55.css";
import "./styles/response-56.css";
import "./styles/response-57.css";
import "./styles/app-detail.css";
import "./styles/publish-app-benchmark.css";
import "./styles/screen-06-scale.css";
import "./styles/public-responsive.css";
import "./styles/founder-shell.css";
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("OpenAppCart root element was not found.");
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <FounderAuthProvider>
          <App />
        </FounderAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
